import JassEnum from './enum';

/**
 * type texmapflags
 */
export default class JassTexMapFlags extends JassEnum {}
